import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMTextArea } from '@insurancemenu/imenu-components-lib';
import {
  IMZipCodeField,
  IMZipCountyField,
  IMZipStateField,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/zip';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useInitiateGroupPageStore } from 'store/pages/initiate-group/pageStore';
import { toJS } from 'mobx';
import SectionTitle from 'components/common/general/SectionTitle';
import {
  INITIATE_GROUP_FORM_ID,
  INITIATE_GROUP_SECTION_MAIN_CONTACT_TEST_ID,
  INITIATE_GROUP_SECTION_NOTES_TEST_ID,
  INITIATE_GROUP_SECTION_PHYSICAL_ADDRESS_TEST_ID,
} from './constants';
import {
  AdditionalDetailsWrapperStyled,
  CollapseStyled,
  FollowingSubsectionTitleStyled,
  IMFormStyled,
  SearchBlockStyled,
  SubsectionTitleStyled,
  ToggleDetailsButtonStyled,
} from './styles';

const InitiateGroupForm: React.FC = observer(() => {
  const {
    searchGroupDelegate: { filteredGroups, resetFilteredGroups },
    groupForm,
    applyGroupSearchQuery,
    selectGroupFromSearch,
  } = useInitiateGroupPageStore();

  const [showDetails, setShowDetails] = useState(false);

  const convertedFilteredGroups = filteredGroups.map((group) => toJS(group));

  const onToggleDetails = (): void => {
    setShowDetails((open) => !open);
  };

  return (
    <IMFormStyled id={INITIATE_GROUP_FORM_ID} formController={groupForm}>
      <SectionTitle title="Group Information" />
      <SearchBlockStyled
        label="Group Name"
        placeholder="Search or create a group"
        width="100%"
        displayValueType="name"
        filteredInfo={convertedFilteredGroups}
        selectButtonText="Use this group"
        resetFilteredItems={resetFilteredGroups}
        onUpdate={applyGroupSearchQuery}
        selectFromSearch={selectGroupFromSearch}
        validationPassed={groupForm.fields.name.value.trim().length > 0}
        htmlType="search"
      />
      <ToggleDetailsButtonStyled
        type="text"
        color="primary"
        size="small"
        uppercase
        rightIconProp={showDetails ? <ChevronUp /> : <ChevronDown />}
        onClick={onToggleDetails}
      >
        {showDetails ? 'Hide Group Details (Optional)' : 'Add Group Details (Optional)'}
      </ToggleDetailsButtonStyled>
      <CollapseStyled show={showDetails}>
        <AdditionalDetailsWrapperStyled>
          <SubsectionTitleStyled
            text="Main Contact Information"
            data-test-id={INITIATE_GROUP_SECTION_MAIN_CONTACT_TEST_ID}
          />
          <IMInputText label="First Name" name="firstName" size="m" />
          <IMInputText label="Last Name" name="lastName" size="m" />
          <IMInputText label="Phone Number" name="primaryPhone" size="m" />
          <IMInputText label="Title " name="title" size="m" />
          <IMInputText label="Email Address" name="primaryEmail" size="full" />
          <FollowingSubsectionTitleStyled
            text="Physical Address"
            data-test-id={INITIATE_GROUP_SECTION_PHYSICAL_ADDRESS_TEST_ID}
          />
          <IMInputText label="City" name="city" size="full" />
          <IMInputText label="Street" name="street" size="m" />
          <IMInputText label="Street 2" name="street2" size="m" />
          <IMZipCodeField size="s" />
          <IMZipStateField size="s" />
          <IMZipCountyField size="s" />
          <FollowingSubsectionTitleStyled text="Notes" data-test-id={INITIATE_GROUP_SECTION_NOTES_TEST_ID} />
          <IMTextArea label="Notes" name="notes" size="full" />
        </AdditionalDetailsWrapperStyled>
      </CollapseStyled>
    </IMFormStyled>
  );
});

export default InitiateGroupForm;
